import { apiInstance } from 'api/utils';
// TODO: remove test1 from url

const policiesActionsApi = {
  retainNoChanges: ({
    portfolio,
    existing_policy
  }: {
    portfolio: any;
    existing_policy: any;
  }) => {
    return apiInstance.request({
      method: 'POST',
      url: `/cases/${portfolio}/existing-policies/${existing_policy}/actions/retain-no-changes/`
    });
  },
  retainRebalance: ({
    portfolio,
    existing_policy,
    split
  }: {
    portfolio: any;
    existing_policy: any;
    split: any;
  }) => {
    return apiInstance.request({
      method: 'POST',
      url: `/cases/${portfolio}/existing-policies/${existing_policy}/actions/retain-rebalance/`,
      data: split
    });
  },
  transferCashFull: ({
    portfolio,
    existing_policy
  }: {
    portfolio: any;
    existing_policy: any;
  }) => {
    return apiInstance.request({
      method: 'POST',
      url: `/cases/${portfolio}/existing-policies/${existing_policy}/actions/transfer-cash-full/`
    });
  },
  transferCashPartial: ({
    portfolio,
    existing_policy,
    split
  }: {
    portfolio: any;
    existing_policy: any;
    split: any;
  }) => {
    return apiInstance.request({
      method: 'POST',
      url: `/cases/${portfolio}/existing-policies/${existing_policy}/actions/transfer-cash-partial/`,
      data: split
    });
  },
  transferReRegisterFull: ({
    portfolio,
    existing_policy,
    split
  }: {
    portfolio: any;
    existing_policy: any;
    split: any;
  }) => {
    return apiInstance.request({
      method: 'POST',
      url: `/cases/${portfolio}/existing-policies/${existing_policy}/actions/transfer-re-register-full/`,
      data: split
    });
  },
  transferReRegisterPartial: ({
    portfolio,
    existing_policy,
    split
  }: {
    portfolio: any;
    existing_policy: any;
    split: any;
  }) => {
    return apiInstance.request({
      method: 'POST',
      url: `/cases/${portfolio}/existing-policies/${existing_policy}/actions/transfer-re-register-partial/`,
      data: split
    });
  },
  surrenderPartial: ({
    portfolio,
    existing_policy,
    split
  }: {
    portfolio: any;
    existing_policy: any;
    split: any;
  }) => {
    return apiInstance.request({
      method: 'POST',
      url: `/cases/${portfolio}/existing-policies/${existing_policy}/actions/surrender-partial/`,
      data: split
    });
  },
  surrenderFull: ({
    portfolio,
    existing_policy,
    split
  }: {
    portfolio: any;
    existing_policy: any;
    split: any;
  }) => {
    return apiInstance.request({
      method: 'POST',
      url: `/cases/${portfolio}/existing-policies/${existing_policy}/actions/surrender-full/`,
      data: split
    });
  },
  retainInternalFundSwitch: ({
    portfolio,
    existing_policy,
    split
  }: {
    portfolio: any;
    existing_policy: any;
    split: any;
  }) => {
    return apiInstance.request({
      method: 'POST',
      url: `/cases/${portfolio}/existing-policies/${existing_policy}/actions/retain-internal-fund-switch/`,
      data: split
    });
  }
};

export default {
  ...policiesActionsApi
};
